/* 
 2026-10-15
*/

import httpCustomer from "./httpServiceCustomer";

const apiEndpoint = "/infoUtilizador";

export function getInfoUtilizador() {
    return httpCustomer.get(apiEndpoint);
}
